import { FC, useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { HeaderMobile } from './HeaderMobile';
import { headerData } from '../../assets/headerData';
import { serviceData } from '../../assets/serviceData';
import { ReactComponent as Menu } from '../../assets/images/svg/menu.svg';
import logoImage from '../../assets/images/logo-picture.jpg';
import logoWords from '../../assets/images/logo-words.jpg';
import phone from '../../assets/images/svg/phone.svg';
import clsx from 'clsx';
import styles from './Header.module.scss';

export const Header: FC = () => {
  const { pathname } = useLocation();
  const [showServiceMenu, setShowServiceMenu] = useState(false);
  const [isOpenMenu, setIsOpenMenu] = useState(false);
  const [classHeader, setClassHeader] = useState('');

  const phoneNumberText = '+1-425-589-9676';
  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  const handleScroll = () => {
    const scrollTop = window.scrollY;
    if (scrollTop > 400) {
      setClassHeader('fixed z-30');
    } else {
      setClassHeader('');
    }
  };

  return (
    <div
      className={`bg-white shadow-lg h-24 md:h-28 ${classHeader} w-full  md:flex items-center justify-between  px-8 md:px-12`}
    >
      <div className="flex justify-between items-center py-2 ">
        <div className="text-2xl font-bold text-gray-950 md:text-3xl">
          <Link to="/" className="flex items-center">
            <img
              src={logoImage}
              alt="LOGO"
              width={80}
              className="transition-transform duration-1000 ease-in-out active:-rotate-180"
            />
            <img src={logoWords} alt="LOGO" width={120} />
          </Link>
        </div>
        <div className="md:hidden" onClick={() => setIsOpenMenu(!isOpenMenu)}>
          <button
            type="button"
            className="block text-gray-950 hover:text-gray-700 focus:text-gray-700 focus:outline-none"
          >
            <Menu />
          </button>
        </div>
      </div>
      <div className="flex-col md:flex-row hidden  md:block -mx-2">
        {headerData.map((nav) => (
          <Link
            key={nav.title}
            to={nav.path}
            onMouseEnter={() =>
              nav.title === 'Services' ? setShowServiceMenu(true) : setShowServiceMenu(false)
            }
            className={clsx(
              'text-gray-950 rounded hover:bg-gray-600 hover:text-gray-100 hover:font-medium py-3 px-3 md:mx-2 relative',
              pathname === nav.path && 'text-white bg-gray-900 ',
            )}
          >
            {nav.title}
          </Link>
        ))}
        <span className={clsx(styles.phone, 'cursor-auto hidden lg:inline-block')}>
          <img src={phone} alt="phone" width={20} className={styles.icon} />
          <span className="text-grey-700">
            {phoneNumberText.split('').map((letter, index) => (
              <motion.span
                key={index}
                initial={{ opacity: 1 }}
                animate={{ opacity: 0.5 }}
                transition={{ duration: 5, repeat: Infinity, delay: index * 0.1 }}
              >
                {letter}
              </motion.span>
            ))}
          </span>
        </span>
        <a
          href="tel:+1-425-589-9676"
          className={clsx(styles.phone, 'cursor-auto hidden md:inline-block lg:hidden')}
        >
          <img src={phone} alt="phone" width={20} className={styles.icon} />
        </a>
        <div
          className={clsx(
            ' bg-white absolute top-20 right-40 w-72 z-40',
            !showServiceMenu ? 'hidden' : 'flex flex-col',
          )}
          onMouseLeave={() => setShowServiceMenu(false)}
        >
          {serviceData.map((nav) => (
            <Link
              onClick={() => setShowServiceMenu(false)}
              key={nav.title}
              to={nav.path}
              className={clsx(
                'text-gray-950  rounded  hover:text-gray-500 hover:font-medium py-2 px-2 md:mx-2',
              )}
            >
              {nav.title}
            </Link>
          ))}
        </div>
      </div>
      <HeaderMobile isOpenMenu={isOpenMenu} setIsOpenMenu={setIsOpenMenu} />
    </div>
  );
};
